<template>
  <!-- Pinta los bloques que entrega /api/terminos/. Vive aparte porque lo usan
       la página /terminos-y-condiciones/ y el modal de aceptación de la reserva,
       y así el texto se ve igual en los dos lados. -->
  <div class="terms-doc">
    <template v-for="(block, index) in blocks" :key="index">
      <h3 v-if="block.type === 'heading' && block.level === 1" class="terms-h1">
        <span class="terms-num">{{ block.number }}.</span> {{ block.text }}
      </h3>
      <h4 v-else-if="block.type === 'heading' && block.level === 2" class="terms-h2">
        <span class="terms-num">{{ block.number }}.</span> {{ block.text }}
      </h4>
      <h5 v-else-if="block.type === 'heading'" class="terms-h3">
        <span class="terms-num">{{ block.number }}.</span> {{ block.text }}
      </h5>

      <ul v-else-if="block.type === 'list'" class="terms-list">
        <li v-for="(item, i) in block.items" :key="i">{{ item }}</li>
      </ul>

      <p v-else class="terms-p">{{ block.text }}</p>
    </template>
  </div>
</template>

<script>
export default {
  name: "TermsContent",
  props: {
    blocks: {
      type: Array,
      default: () => [],
    },
  },
};
</script>

<style scoped>
.terms-doc {
  color: var(--color-theater-text);
  font-size: 14px;
  line-height: 1.7;
}

.terms-h1,
.terms-h2,
.terms-h3 {
  font-family: var(--font-family-heading);
  color: #fff;
  margin: 26px 0 10px;
}

.terms-h1 {
  font-size: 16px;
  font-weight: 800;
  letter-spacing: 0.6px;
  padding-bottom: 8px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.12);
}

.terms-h2 {
  font-size: 14px;
  font-weight: 800;
}

.terms-h3 {
  font-size: 13px;
  font-weight: 700;
  color: rgba(255, 255, 255, 0.86);
}

/* La numeración en rojo hace navegable un documento de 15 páginas. */
.terms-num {
  color: #e2334c;
  margin-right: 4px;
}

.terms-p {
  margin: 0 0 12px;
  text-align: justify;
}

.terms-list {
  margin: 0 0 14px;
  padding-left: 20px;
}

.terms-list li {
  margin-bottom: 8px;
}

@media (max-width: 600px) {
  .terms-p {
    text-align: left;
  }
}
</style>
